export default {
  'ean-code': (field, args) => `${field} est incorrect`,
  'greater-than': (field, minValue) => `La valeur doit être supérieure à ${minValue}`,
  'gsm-number': (field, args) => 'Le numéro doit commencer par 4 et se composer de 9 chiffres',
  'index-value': (field, args) => 'Votre index ne doit contenir que des chiffres, veuillez vérifier la valeur encodée',
  'landline-number': (field, args) => `Le numéro ne doit pas contenir le zéro du préfixe et se compose de 8 ou 9 chiffres`,
  'max-digits': (field, maxDigits) => `L'index peut contenir au maximum ${maxDigits} chiffres`,
  'meter-number': (field, args) => `Le numéro se compose des 4 derniers chiffres de votre compteur`,
  'only-letters': (field, args) => `Veuillez n'encoder que des lettres`,
  're-captcha': (field, args) => `Merci de compléter le captcha. Ceci permet une vérification supplémentaire contre les logiciels malveillants.`,
  'reference-number': (field, args) => `${field} se compose de 8 chiffres`,
  'no-accents': (field, args) => `${field} ne peut pas contenir d'accent`,
  'no-special-chars-email': (field, args) => `${field} est incorrect`
}
